export default function () {
  var ua = navigator.userAgent.toLowerCase()
  let platform = navigator?.userAgentData?.platform.toLowerCase() || 'unknown'
  const platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
  const isMobile = /ios|android|webos/.test(platformName)
  if (!isMobile) {
    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    (function(){
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='https://embed.tawk.to/660d585ca0c6737bd127e31f/1hqi22aqh';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin','*');
    s0.parentNode.insertBefore(s1,s0);
    })();

  }

 
}

export const noLiveChatScript =''
 
